import { FC, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Grid2 as Grid, Paper, Typography } from '@mui/material'
import theme from '@rfh-core/theme'

import { Divider } from 'src/common/components'

type RuleTextFieldProps = {
  rule: string
}

const RuleTextField: FC<RuleTextFieldProps> = forwardRef(({ rule }, ref) => {
  const paperColor = theme.rfhColors.white
  const { t } = useTranslation()

  return (
    <Paper elevation={10} square={false} sx={{ background: paperColor }}>
      <Box p={3} ref={ref}>
        <Grid container flexDirection={'column'}>
          <Grid size={12}>
            <Typography variant={'subtitle2'}>
              {t('auctionGroupAllocation.auctionGroupRuleModalTitle')}
            </Typography>
          </Grid>
          <Grid size={12}>
            <Divider />
          </Grid>
          <Grid
            size={12}
            sx={{
              whiteSpace: 'pre-line',
              wordWrap: 'break-word',
            }}
          >
            <Typography variant={'body2'}>{rule}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  )
})

export default RuleTextField
